import React from 'react';
import './logo.css';

import logo from '../../../assets/pbLogo.svg';

interface Props {
    className?: string;
    style?: React.CSSProperties;
}

const Logo = ({ className, style }: Props) => (
    <img className={`logo ${className ?? ''}`} style={style} src={logo} alt="logo" />
);

export default Logo;
